import React from 'react';
import styles from './ChatroomMemberList.scss';
import { MemberList } from '../ChatCreation/MemberList/MemberList';
import { connect } from 'react-redux';
import {
  headerFontFamily,
  messagesFontFamily,
  primaryColorOrDefault,
  textColorOrDefault,
} from '../../reducers';
import utils from '../../services/utils';
import { InjectedTranslateProps, translate } from 'react-i18next';
import Add from '../../icons/dist/components/add';
import { SiteMember } from '../ChatCreation/ChatCreation';
import { messagesFont } from '../../../../test/v1/mock/wix-mock';

interface ChatroomMemberListProps extends InjectedTranslateProps {
  primaryColor: string;
  textColor: string;
  onAddMembers: Function;
  onRemoveMember?(id: string): any;
  members: SiteMember[];
  adminMemberIds?: string[];
  visitorId: string;

  messageFont: string;
  headerFont: string;
}

interface ChatroomMemberListState {}

class _ChatroomMemberList extends React.Component<
  ChatroomMemberListProps,
  ChatroomMemberListState
> {
  getEntrySuffix = () => {
    const { primaryColor, onRemoveMember, t, visitorId } = this.props;

    if (!onRemoveMember) {
      return;
    }

    return (id: string) => {
      if (visitorId === id) {
        return;
      }

      return (
        <button
          data-hook="remove-button"
          className={styles.removeButton}
          style={{ color: primaryColor }}
          onClick={() => onRemoveMember(id)}
        >
          {t('chatroom-member-list.remove-member-button.label')}
        </button>
      );
    };
  };

  getBadges = () => {
    const { primaryColor, adminMemberIds, t } = this.props;

    const badges = [
      {
        condition: (id: string) =>
          adminMemberIds && adminMemberIds.indexOf(id) !== -1,
        view: (id: string) => (
          <span
            className={styles.badge}
            style={{ backgroundColor: utils.getRgbA(primaryColor, 0.3) }}
          >
            {t('chatroom-member-list.badges.admin')}
          </span>
        ),
      },
    ];

    return (id: string) =>
      badges
        .filter((badge) => badge.condition(id))
        .map((badge) => badge.view(id));
  };

  render() {
    const {
      t,
      members,
      primaryColor,
      textColor,
      onAddMembers,
      messageFont,
    } = this.props;

    return (
      <div
        className={styles.chatroomMemberList}
        style={{ fontFamily: messageFont }}
      >
        <div className={styles.addMembers}>
          <button
            className={styles.addMembersButton}
            data-hook="add-members-button"
            onClick={() => onAddMembers()}
          >
            <span
              style={{ color: primaryColor }}
              className={styles.addMembersButtonIcon}
            >
              <Add size="36px" />
            </span>
            {t('chatroom-member-list.add-members-button.label')}
          </button>
        </div>
        <div className={styles.memberList}>
          <MemberList
            members={members}
            entrySuffix={this.getEntrySuffix()}
            badges={this.getBadges()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  primaryColor: primaryColorOrDefault(state),
  textColor: textColorOrDefault(state),
  visitorId: state.chatInitResult.visitorId,
  messageFont: messagesFontFamily(state),
  headerFont: headerFontFamily(state),
});

const mapDispatchToProps = (state) => ({});

export const ChatroomMemberList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(translate()(_ChatroomMemberList));
